import { render, staticRenderFns } from "./AreaModal.vue?vue&type=template&id=0ffe51db&scoped=true"
import script from "./AreaModal.vue?vue&type=script&lang=js"
export * from "./AreaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe51db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffe51db')) {
      api.createRecord('0ffe51db', component.options)
    } else {
      api.reload('0ffe51db', component.options)
    }
    module.hot.accept("./AreaModal.vue?vue&type=template&id=0ffe51db&scoped=true", function () {
      api.rerender('0ffe51db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/table/AreaModal.vue"
export default component.exports